import getSteelMakerName from '../../utils/getSteelMakerName';
import type { ValueGetterParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';
import type { Language, SelectOption, SteelMaker } from '../../types/common';

/**
 * steelMaker[]からフィルタ用の文字列を生成する。
 * contextにcurrentLang, steelMakerが存在する必要がある。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const steelMakerFilterValueGetter = (params: ValueGetterParams) => {
  const value: SteelMaker | SteelMaker[] = params.getValue('steelMaker');
  const steelMakerCodes: SteelMaker[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const steelMaker: OptionsType<SteelMaker>[] | undefined = params.context?.steelMaker;
  // 鉄鋼メーカーコードの配列を鉄鋼メーカー名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const steelMakerNames: string[] = steelMakerCodes.map((code) => {
    const steelMakerName: string = getSteelMakerName(code, steelMaker, currentLang.value);
    return steelMakerName;
  });
  const filterValue: string = steelMakerNames.join(', ');
  return filterValue;
};

export default steelMakerFilterValueGetter;
